import { useSelector } from "react-redux";
import { Table } from "react-bootstrap";
import Select from "react-select";

import MultiSelect from "../Form/MultiSelect/MultiSelect";
import { customInputStyle } from "../ReactSelect/NoOptions.styles";
import { ESTATE_PARENT_PLURAL, ESTATE_PLURAL } from "@/services/estateLabels";

import { ReactComponent as RemoveSvg } from "@/assets/images/desktop/remove.svg";

const BusinessCenterParentTable = ({ data, handleInputChange, addRow, removeRow }) => {
	const { customer } = useSelector((state) => state.auth.user);

	return (
		<>
			<Table hover>
				<thead>
					<tr>
						<th className="border-0" style={{ width: "20%" }}>
							Centro de Costo<small className="text-danger">*</small>
						</th>
						<th className="border-0" style={{ width: "15%" }}>
							{ESTATE_PARENT_PLURAL} <small className="text-danger">*</small>
						</th>
						<th className="border-0" style={{ width: "15%" }}>
							{ESTATE_PLURAL} <small className="text-danger">*</small>
						</th>
						{!customer.use_sectors && (
							<>
								<th className="border-0" style={{ width: "15%" }}>
									Superficie (ha) <small className="text-danger">*</small>
								</th>
								<th className="border-0" style={{ width: "15%" }}>
									Especie <small className="text-danger">*</small>
								</th>
								<th className="border-0" style={{ width: "15%" }}>
									Variedad <small className="text-danger">*</small>
								</th>
							</>
						)}
						<th className="border-0" style={{ width: "5%" }}>
							Acciones
						</th>
					</tr>
				</thead>
				<tbody>
					{data.businessCenterParents.length === 0 ? (
						<tr>
							<td colSpan={6} className="text-center">
								No hay Centros de Costo agregados
							</td>
						</tr>
					) : (
						data.businessCenterParents.map((businessCenterParent, index) => {
							const optionsEstatesParents = [...data.estateParents];
							const optionsEstates = data.estates.filter((estate) => estate.estate_parent_id === businessCenterParent.estateParents?.value);

							return (
								<tr key={index}>
									<td className="position-relative table-td-implementation input-text">
										<input
											type="text"
											className={`form-control ${businessCenterParent.name ? "" : "is-invalid"}`}
											placeholder="Nombre de centro de costo"
											style={customInputStyle}
											required
											value={businessCenterParent.name || ""}
											onChange={(e) => handleInputChange(index, "name", e.target.value)}
										/>
										{businessCenterParent.isNew && (
											<div className="diagonal-badge">
												<span className="badge badge-info">Nuevo</span>
											</div>
										)}
									</td>
									<>
										<td className="table-td-implementation">
											<Select
												key={`estate_parent_selector_${index}`}
												options={optionsEstatesParents}
												onChange={(e) => handleInputChange(index, "estateParents", e)}
												value={businessCenterParent.estateParents ? businessCenterParent.estateParents : []}
												isSelectAll={true}
												menuPlacement={"bottom"}
												placeholder={"Selecciona campos"}
												isClearable={false}
												styles={{
													placeholder: (provided) => ({
														...provided,
														fontSize: "12px",
													}),
												}}
											/>
										</td>
										<td className="table-td-implementation">
											<MultiSelect
												key={`estate_selector_${index}`}
												options={optionsEstates}
												onChange={(e) => handleInputChange(index, "estates", e)}
												value={businessCenterParent.estates ? businessCenterParent.estates : []}
												isSelectAll={true}
												menuPlacement={"bottom"}
												placeholder={"Selecciona bodegas"}
												isClearable={false}
											/>
										</td>
									</>
									<td className="table-td-implementation input-text text-center">
										<div className="btn-group">
											<RemoveSvg
												style={{ cursor: "pointer", width: "1.5em", height: "1.5em" }}
												onClick={() => removeRow(index, businessCenterParent.isNew)}
											/>
										</div>
									</td>
								</tr>
							);
						})
					)}
					<tr>
						<td className="border-0">
							<button
								className="btn bg-agro-outline-color btn-block tr-btn"
								onClick={addRow}
								style={{ height: "30px", fontSize: "12px", width: "200px" }}
							>
								<i className="ti-plus"></i> Agregar
							</button>
						</td>
					</tr>
				</tbody>
			</Table>
		</>
	);
};

export default BusinessCenterParentTable;
